module.exports = __webpack_public_path__ + "static/media/oniku.68466a14.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/oniku.svg
// module id = 781
// module chunks = 0